import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../config/webpack/loaders/svg-sprite/sprite-runtime-with-turbolinks.js";
var symbol = new SpriteSymbol({
  "id": "icon__check-square",
  "use": "icon__check-square-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 24 24\" id=\"icon__check-square\"><defs><style>#icon__check-square .cls-1{fill:#000;fill-rule:evenodd}</style></defs><path d=\"M23 24H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v22a1 1 0 0 1-1 1zM22 2H2v20h20V2zM6.624 11.219l4.253 3.402 6.371-7.279a1 1 0 1 1 1.504 1.317l-7 7.999a.995.995 0 0 1-1.376.123l-5.001-4a1 1 0 0 1 1.249-1.562z\" class=\"cls-1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol